<mos-modal #modal>
	<!-- Condition exists to trigger animations -->
	@if (modal.shouldDisplayContent()) {
	<div class="container" [mosLeaveSync]="'container-out'">
		<mos-header i18n="@@event.artbook.title">Aide-nous à réaliser l'artbook</mos-header>

		<div class="artbook-container">
			<mos-canvas-emitter [config]="emitter1Config" #emitter1 />

			<div class="artbook"></div>

			<mos-canvas-emitter [config]="emitter2Config" #emitter2 />
		</div>

		<div class="infos">
			<div class="timer">
				<div class="remaining-time">
					<span class="remaining-time-icon"></span>
					Temps restant : {{ remainingTime() | date:'dd \'j\' HH \'h\' mm \'m\'' }}
				</div>
			</div>
			@if (committed(); as committed) {
			<div class="gauge">
				<div class="inner-gauge-container">
					<div [style.width.%]="Math.min(100, committed)" class="inner-gauge"></div>
				</div>
				<div class="gauge-text">{{ committed }} / {{ goal() }} préventes</div>
			</div>
			}
			<p class="notice">Minimum de {{ goal() }} préventes pour lancer la création.</p>
		</div>

		<div class="offers">
			<a class="button" href="https://fr.ulule.com/l-artbook-de-memory-of-souls/" target="_blank"
				>Pré-commander</a
			>
		</div>

		<div class="button-container">
			<a
				role="button"
				tabindex="0"
				(click)="leave()"
				(keydown.enter)="leave()"
				(keydown.space)="leave(); $event.preventDefault()"
			>
				<span i18n="@@common.no-thanks">Non, merci !</span>
			</a>
		</div>
	</div>
	}
</mos-modal>
